<template>
  <div class="directory-container">
    <div class="heading">
      <h3 :style="{ 'font-weight': '700', 'font-size': '32px', 'line-height': '42px', color: '#0F1734' }">
        My Dove Directory
      </h3>
      <div class="d-flex flex-row private-container">
        <font-awesome-icon class="mr-2" :style="{ color: '#647490', width: '12.4px' }" :icon="['fas', 'eye-slash']" />
        <p class="private">Private to you</p>
      </div>
    </div>
    <p class="sub-title">
      The Dove Directory is intended to help users have quick access to their saved healthcare providers, medical professionals, hospitals, clinics and healthcare businesses. Please visit individual profile pages on MyCircles, click on the 3 dots next to the profile image, and Save to DoveDirectory.
    </p>
    <div class="mb-4">
      <!-- Saved Physicians -->
      <h4 class="saved-title mt-4">Saved Physicians</h4>
      <div v-if="doctor" class="d-flex justify-content-center mt-3">
        <div>
          <div class="spinner-border position-absolute spinner-class"></div>
        </div>
        <div :style="{ 'margin-left': '-14px', 'margin-top': '40px' }">
          Loading...
        </div>
      </div>
      <div v-if="!doctor && SavedPhy.length > 0" class="saved">
        <div class="mb-2" v-for="data in SavedPhy" :key="data.saved.id">
          <DoveDirectoryCard :info="data.saved" :rating="data.rating" :review_count="data.review_count" :core_ratings="data.core_ratings" :type="'physician'" />
        </div>
        <div class="btns mt-3" v-if="PhyCount > 3">
          <button class="submit-btn" @click="$router.push({ name: 'DoveDirectoryfilterpage', params: { role: 'doctor' } })" :style="{ color: getPrimaryColor() }">
            View {{ PhyCount - 3 }} more Physicians
            <font-awesome-icon size="2x" class="mr-2" :style="{ transform: 'scale(0.7)', width: '30px', marginTop: '-4px', color: getPrimaryColor() }" :icon="['fa', 'arrow-right']" />
          </button>
        </div>
      </div>
      <div v-if="!doctor && SavedPhy.length === 0" class="no-result">
        <span class="text">You have not saved any Physicians.</span>
        <a-button
          :style="{ background: getSecondaryColor(), 'pointer-events': 'all', 'font-size': '14px', 'border-radius': '6px', padding: '12px 24px' }"
          class="font-white primary-button profile-btn"
          @click="$router.push({ name: 'ProviderSearch' })"
        >
          Search and Save
        </a-button>
      </div>

      <!-- Saved Medical Phy -->
      <h4 class="saved-title mt-4">Saved Advanced Practice Providers</h4>
      <div v-if="hcp" class="d-flex justify-content-center mt-3">
        <div>
          <div class="spinner-border position-absolute spinner-class"></div>
        </div>
        <div :style="{ 'margin-left': '-14px', 'margin-top': '40px' }">
          Loading...
        </div>
      </div>
      <div class="saved" v-if="!hcp && SavedMedicalPhy.length > 0" :style="{ 'margin-top': '24px' }">
        <div class="mb-2" v-for="data in SavedMedicalPhy" :key="data.saved.id">
          <DoveDirectoryCard :info="data.saved" :rating="data.rating" :review_count="data.review_count" :core_ratings="data.core_ratings" :type="'hcp'" />
        </div>
        <div class="btns mt-3" v-if="MedicalPhyCount > 3">
          <button class="submit-btn" @click="$router.push({ name: 'DoveDirectoryfilterpage', params: { role: 'hcp' } })" :style="{ color: getPrimaryColor() }">
            View {{ MedicalPhyCount - 3 }} more Advanced Practice Providers
            <font-awesome-icon size="2x" class="mr-2" :style="{ transform: 'scale(0.7)', width: '30px', marginTop: '-4px', color: getPrimaryColor() }" :icon="['fa', 'arrow-right']" />
          </button>
        </div>
      </div>
      <div v-if="!hcp && SavedMedicalPhy.length === 0" class="no-result">
        <span class="text">You have not saved any Advanced Practice Providers.</span>
        <a-button
          :style="{ background: getSecondaryColor(), 'pointer-events': 'all', 'font-size': '14px', 'border-radius': '6px', padding: '12px 24px' }"
          class="font-white primary-button profile-btn"
          @click="$router.push({ name: 'PracticeSearch' })"
        >
          Search and Save
        </a-button>
      </div>

      <h4 class="saved-title mt-4">Saved Hospitals</h4>
      <div v-if="hospital_administrator" class="d-flex justify-content-center mt-3">
        <div>
          <div class="spinner-border position-absolute spinner-class"></div>
        </div>
        <div :style="{ 'margin-left': '-14px', 'margin-top': '40px' }">
          Loading...
        </div>
      </div>
      <div class="saved" v-if="!hospital_administrator && SavedHospital.length > 0" :style="{ 'margin-top': '24px' }">
        <div class="mb-2" v-for="data in SavedHospital" :key="data.saved.id">
          <DoveDirectoryCard :info="data.saved" :rating="data.rating" :review_count="data.review_count" :core_ratings="data.core_ratings" :type="'hospital_administrator'" />
        </div>
        <div class="btns mt-3" v-if="hospitalCount > 3">
          <button class="submit-btn" @click="$router.push({ name: 'DoveDirectoryfilterpage', params: { role: 'hospital_administrator' } })" :style="{ color: getPrimaryColor() }">
            View {{ hospitalCount - 3 }} more hospitals
            <font-awesome-icon size="2x" class="mr-2" :style="{ transform: 'scale(0.7)', width: '30px', marginTop: '-4px', color: getPrimaryColor() }" :icon="['fa', 'arrow-right']" />
          </button>
        </div>
      </div>
      <div v-if="!hospital_administrator && SavedHospital.length === 0" class="no-result">
        <span class="text">You have not saved any Hospitals.</span>
        <a-button
          :style="{ background: getSecondaryColor(), 'pointer-events': 'all', 'font-size': '14px', 'border-radius': '6px', padding: '12px 24px' }"
          class="font-white primary-button profile-btn"
          @click="$router.push({ name: 'HospitalSearch' })"
        >
          Search and Save
        </a-button>
      </div>

      <h4 class="saved-title mt-4">Saved Clinics</h4>
      <div v-if="clinic_administrator" class="d-flex justify-content-center mt-3">
        <div>
          <div class="spinner-border position-absolute spinner-class"></div>
        </div>
        <div :style="{ 'margin-left': '-14px', 'margin-top': '40px' }">
          Loading...
        </div>
      </div>
      <div class="saved" v-if="!clinic_administrator && SavedClinics.length > 0" :style="{ 'margin-top': '24px' }">
        <div class="mb-2" v-for="data in SavedClinics" :key="data.saved.id">
          <DoveDirectoryCard :info="data.saved" :rating="data.rating" :review_count="review_count" :core_ratings="data.core_ratings" :type="'clinic_administrator'" />
        </div>
        <div class="btns mt-3" v-if="clinicsCount > 3">
          <button class="submit-btn" @click="$router.push({ name: 'DoveDirectoryfilterpage', params: { role: 'clinic_administrator' } })" :style="{ color: getPrimaryColor() }">
            View {{ clinicsCount - 3 }} more clinics
            <font-awesome-icon size="2x" class="mr-2" :style="{ transform: 'scale(0.7)', width: '30px', marginTop: '-4px', color: getPrimaryColor() }" :icon="['fa', 'arrow-right']" />
          </button>
        </div>
      </div>
      <div v-if="!clinic_administrator && SavedClinics.length === 0" class="no-result">
        <span class="text">You have not saved any Clinics.</span>
        <a-button
          :style="{ background: getSecondaryColor(), 'pointer-events': 'all', 'font-size': '14px', 'border-radius': '6px', padding: '12px 24px' }"
          class="font-white primary-button profile-btn"
          @click="$router.push({ name: 'ClinicSearch' })"
        >
          Search and Save
        </a-button>
      </div>

      <h4 class="saved-title mt-4">Saved Non-For-Profits</h4>
      <div v-if="nfp_administrator" class="d-flex justify-content-center mt-3">
        <div>
          <div class="spinner-border position-absolute spinner-class"></div>
        </div>
        <div :style="{ 'margin-left': '-14px', 'margin-top': '40px' }">
          Loading...
        </div>
      </div>
      <div class="saved" v-if="!nfp_administrator && SavedNfp.length > 0" :style="{ 'margin-top': '24px' }">
        <div class="mb-2" v-for="data in SavedNfp" :key="data.saved.id">
          <DoveDirectoryCard :info="data.saved" :rating="data.rating" :review_count="review_count" :core_ratings="data.core_ratings" :type="'nfp_administrator'" />
        </div>
        <div class="btns mt-3" v-if="nfpCount > 3">
          <button class="submit-btn" @click="$router.push({ name: 'DoveDirectoryfilterpage', params: { role: 'nfp_administrator' } })" :style="{ color: getPrimaryColor() }">
            View {{ nfpCount - 3 }} more Nfps
            <font-awesome-icon size="2x" class="mr-2" :style="{ transform: 'scale(0.7)', width: '30px', marginTop: '-4px', color: getPrimaryColor() }" :icon="['fa', 'arrow-right']" />
          </button>
        </div>
      </div>
      <div v-if="!nfp_administrator && SavedNfp.length === 0" class="no-result">
        <span class="text">You have not saved any Non-For-Profits.</span>
        <a-button
          :style="{ background: getSecondaryColor(), 'pointer-events': 'all', 'font-size': '14px', 'border-radius': '6px', padding: '12px 24px' }"
          class="font-white primary-button profile-btn"
          @click="$router.push({ name: 'NFPSearch' })"
        >
          Search and Save
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import { faEyeSlash } from "@fortawesome/pro-solid-svg-icons"
import { faMapMarkerAlt } from "@fortawesome/pro-light-svg-icons"
import { library } from "@fortawesome/fontawesome-svg-core"
library.add(faEyeSlash, faMapMarkerAlt)
import userRepository from "../../repositories/userRepository"
import DoveDirectoryCard from "./DoveDirectoryCard.vue"
import ReviewStar from "../Users/Doctor/reviewstarforcircle.vue"
export default {
  name: "MyDoveDirectory",
  data() {
    return {
      savedList: [],
      SavedPhy: [],
      PhyCount: undefined,
      SavedMedicalPhy: [],
      MedicalPhyCount: undefined,
      SavedHospital: [],
      hospitalCount: undefined,
      SavedClinics: [],
      clinicsCount: undefined,
      SavedNfp: [],
      nfpCount: undefined,
      doctor: true,
      hcp: true,
      hospital_administrator: true,
      clinic_administrator: true,
      nfp_administrator: true,
    }
  },
  components: {
    ReviewStar,
    DoveDirectoryCard,
  },
  mounted() {
    this.getMyDoveDirectoryData("doctor")
    this.getMyDoveDirectoryData("hcp")
    this.getMyDoveDirectoryData("hospital_administrator")
    this.getMyDoveDirectoryData("clinic_administrator")
    this.getMyDoveDirectoryData("nfp_administrator")
  },
  methods: {
    getMyDoveDirectoryData(role) {
      this[role] = true
      userRepository
        .getMyDoveDirectory(1, 3, this.currentCircle.id, this.authUser.user.id, this.authUser.user.role, role)
        .then(res => {
          this.savedList = res.data.data.data
          console.log(this.savedList)

          if (this.savedList && this.savedList.length > 0) {
            if (role === "doctor") {
              this.SavedPhy = this.savedList
              this.PhyCount = res.data.data.paginator.total_count
            }
            if (role === "hcp") {
              this.SavedMedicalPhy = this.savedList
              this.MedicalPhyCount = res.data.data.paginator.total_count
            }
            if (role === "clinic_administrator") {
              this.SavedClinics = this.savedList
              this.clinicsCount = res.data.data.paginator.total_count
            }
            if (role === "hospital_administrator") {
              this.SavedHospital = this.savedList
              this.hospitalCount = res.data.data.paginator.total_count
            }
            if (role === "nfp_administrator") {
              this.SavedNfp = this.savedList
              this.nfpCount = res.data.data.paginator.total_count
            }
          }
          this[role] = false
        })
        .catch(err => {
          this[role] = false
          console.log(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.directory-container {
  .heading {
    .private {
      font-weight: 700;
      font-size: 12px;
      line-height: 14px;
      text-align: center;
      color: #647490;
    }
    .private-container {
      padding: 4px 8px;
      gap: 4px;
      width: 120px;
      height: 22px;
      background: #f1f5f9;
      border-radius: 4px;
      margin-bottom: 24px;
    }
  }

  .reviews {
    margin-top: 6px;
    text-align: center;
    p {
      margin-bottom: 0px;
    }
  }

  .sub-title {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #647490;
  }
  .saved-title {
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    color: #0f1734;
  }
  .saved {
    margin-top: 15px;
    .recommend {
      align-items: center;
      padding: 4px 8px;
      gap: 4px;
      width: 115px;
      height: 22px;
      background: #f1edff;
      border-radius: 4px;
      display: flex;
      font-weight: 700;
      font-size: 12px;
      line-height: 14px;
      text-align: center;
      color: #906eff;
    }

    .king_icon {
      align-items: center;
      padding: 4px 8px;
      gap: 4px;
      width: 30px;
      height: 22px;
      background: #fff0d6;
      border-radius: 4px;
      display: flex;
    }
    .doc-name {
      font-weight: 700;
      font-size: 20px;
      line-height: 30px;
      text-transform: capitalize;
      color: #0f1734;
    }
    .tags_container {
      .tags {
        padding: 4px 8px;
        width: 70px;
        height: 22px;
        border-radius: 4px;

        .tag {
          font-weight: 700;
          font-size: 12px;
          line-height: 14px;
          text-align: center;
        }
      }
    }

    .doc-name {
      font-weight: 700;
      font-size: 20px;
      line-height: 30px;
      text-transform: capitalize;
      color: #0f1734;
    }
    .doc-number {
      font-weight: 700;
      font-size: 14px;
      line-height: 21px;
      color: #0f1734;
    }
    .doc-loc {
      font-weight: 700;
      font-size: 14px;
      line-height: 21px;
      color: #94a3b8;
      word-break: break-all;
    }

    .doc-miles {
      font-weight: 700;
      font-size: 14px;
      line-height: 21px;
      color: #0f1734;
    }

    .btns {
      .submit-btn {
        padding: 8px;
        gap: 4px;
        width: 790px;
        height: 46px;
        background: #f1f5f9;
        border-radius: 8px;
        border: none;
        align-items: center;
        display: flex;
        justify-content: center;
      }

      @media screen and (max-width: "769px") {
        .submit-btn {
          width: 100% !important;
        }
      }
    }

    .divider {
      border: 1px solid #cbd5e1;
    }

    .phy-name {
      width: 294px;
      height: 108px;
    }

    .phy-details {
      width: 283px;
      height: 111px;
    }
  }
}
.no-result {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  gap: 15px;
  width: 100%;
  background: #f1f5f9;
  border-radius: 8px;
  .text {
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    text-align: center;
    color: #33415f;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/MyDoveDirectory.vue